import { CreateBase, Form, useTranslate } from "ra-core";
import { CancelButton } from "@/components/admin/cancel-button";
import { SaveButton } from "@/components/admin/form";
import { Card, CardContent } from "@/components/ui/card";

import { ProgramInputs } from "./ProgramInputs";

export const ProgramCreate = () => {
  const translate = useTranslate();
  return (
    <CreateBase redirect="show">
      <div className="mt-2 flex">
        <div className="flex-1">
          <Form defaultValues={{ active: true }}>
            <Card>
              <CardContent>
                <ProgramInputs />
                <div
                  role="toolbar"
                  className="flex pt-4 flex-row justify-end gap-2"
                >
                  <CancelButton />
                  <SaveButton
                    label={translate("resources.programs.action.create")}
                  />
                </div>
              </CardContent>
            </Card>
          </Form>
        </div>
      </div>
    </CreateBase>
  );
};
